import { BaseModel } from './BaseModel';
import Redeem from './Redeem';

export class RedeemCode extends BaseModel {
  static get entity() {
    return 'redeem-codes';
  }

  static get fk() {
    return 'redeem_code_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      code: this.attr(null),
      mode: this.attr(null),
      learning_unit: this.attr(null),
      reused: this.boolean(false),
      available_usage: this.attr(null),
      redeems: this.hasMany(Redeem, 'redeem_code_id'),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      find(params = {}) {
        return this.get('/redeem-codes', { params });
      },

      redeem(body = {}) {
        return this.post('/redeem-codes/redeem', body);
      },

      /**
       * Redeem a stack of learning units using redeem code
       *
       * @param {Object} body - Request payload
       * @param {string} body.code - The redeem code string
       * @param {number} [body.stack] - stack ID for validation
       *
       * @returns {Promise<Object>} stack object
       */
      redeemStack(body = {}) {
        return this.post('/redeem-codes/redeem-stack', body);
      }
    }
  };
}

export default RedeemCode;
